export default function (Component) {
Component.options.__condensed = ""
}